import { Pipe, PipeTransform } from '@angular/core';


const defaultCharCollection: { Char: string, Replacement: string}[] =
[
    { Char : " ", Replacement : "-" },
    { Char : "\"",Replacement : ""},
    { Char : "'", Replacement : ""},
    { Char : "%", Replacement : ""},
    { Char : ".", Replacement : ""},
    { Char : ";", Replacement : ""},
    { Char : "/", Replacement : ""},
    { Char : "\\",Replacement : ""},
    { Char : ":", Replacement : ""},
    { Char : "#", Replacement : ""},
    { Char : "+", Replacement : "" },
    { Char : "*", Replacement : "" },
    { Char : "&", Replacement : "" },
    { Char : "?", Replacement : "" },
    { Char : "æ", Replacement : "ae" },
    { Char : "ä", Replacement : "a" },
    { Char : "ø", Replacement : "o" },
    { Char : "ö", Replacement : "o" },
    { Char : "å", Replacement : "a" },
    { Char : "ü", Replacement : "u" },
    { Char : "ë", Replacement : "e" },
    { Char : "ß", Replacement : "ss" },
    { Char : "|", Replacement : "" },
    { Char : "<", Replacement : "" },
    { Char : ">", Replacement : "" },
    { Char : ";0=", Replacement : "/"}
];

@Pipe({
    name: 'urlify',
})
export class UrlifyPipe implements PipeTransform {
    transform(value: string | string[]): string|string[] {
        if (typeof value === 'string') {
            return this.urlify(value);
        }
        if (Array.isArray(value)) {
            return value.map((v) => this.urlify(v));
        }
        return value;
    }

    urlify(value: string): string {
        let transformedValue = value.trim().toLowerCase();

        defaultCharCollection.forEach((char) => (transformedValue = transformedValue.replace(char.Char, char.Replacement)));

        return transformedValue;
    }
}
